import Reveal from '@/components/base/Reveal';
import { whoBestWith } from '@/mocks/about';

export default function WhoBestWith() {
  return (
    <section className="relative py-20 md:py-28 bg-background-100/40">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
            Who Josh Works Best With
          </span>
          <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            Built for Business Owners Who Are Serious About Growth
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
          <Reveal>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {whoBestWith.map((item) => (
                <li key={item} className="flex items-start gap-2.5">
                  <span className="w-5 h-5 mt-0.5 shrink-0 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-400">
                    <i className="ri-check-line text-sm"></i>
                  </span>
                  <span className="text-sm text-foreground-700 leading-relaxed">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal delay={100}>
            <div className="rounded-2xl border border-primary-500/20 bg-background-50 p-8">
              <p className="font-heading font-semibold text-lg text-foreground-950 leading-snug">
                Built for established businesses doing at least ~$300,000
                annually.
              </p>
              <p className="mt-4 text-foreground-600 leading-relaxed">
                This is not beginner marketing advice. It is growth strategy for
                businesses that already have something worth scaling.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
